import _ from 'lodash';
import { observer } from 'mobx-react-lite';

import Button from '@/components/goalbased/Questionarie/Button/Button';
import type { QuizButtonSectionRecordModelType } from '@/models/api';
import { useStore } from '@/models/root-store';

type Props = {
  daySection: QuizButtonSectionRecordModelType;
};

const Plans: React.FC<Props> = observer(({ daySection }) => {
  const { cartStore } = useStore();
  const { goalBased } = cartStore;

  return (
    <div className="my-14 px-4 pb-52 md:p-0">
      <div className="mb-8 font-interBold text-4xl leading-9 text-black md:mb-6">
        {daySection.questionText}
      </div>
      <div className="lg:flex">
        {_.map(daySection.quizAnswers, (day, i: any) => {
          const dayValue = Number(day?.value);
          const activeClass =
            goalBased.numberOfDays === dayValue ? 'secondary' : 'primary';

          return (
            <Button
              key={i}
              className="mb-6 w-full justify-center px-3 py-5 font-interBold leading-4 last:mb-0 last:mr-0 lg:mb-0 lg:mr-4 lg:w-44 lg:py-4 lg:leading-6"
              theme={activeClass}
              onClick={() => {
                goalBased.setPreset('numberOfDays', dayValue);
              }}
            >
              {dayValue} days per week
            </Button>
          );
        })}
      </div>
    </div>
  );
});

export default Plans;
